import { Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SelfEvaluationList({ selfEvaluationList }) {
  const headers = ['Standard', 'Self-Rating']
  const { t } = useTranslation()

  return (
    <Box width={'100%'}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                <TableCell key={index}>
                    {t(header)}
                </TableCell>
              ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {selfEvaluationList?.map((item, index) => (
                <TableRow key={`self-eval-${index}`}>
                  <TableCell>
                    Standard {index + 1}
                  </TableCell>
                  <TableCell>
                    {
                      item?.adminEvaluationRatings?.length > 0 ? 
                      (() => {
                        const score = item?.adminEvaluationRatings[0]?.adminEvaluationRubric?.score;
                        const performance = item?.adminEvaluationRatings[0]?.adminEvaluationRubric?.performance;
                        let color = 'warning';
                        if (score >= 3) color = 'success';
                        else if (score === 2) color = 'warning';
                        else if (score === 1) color = 'error';
                        return <Chip label={`${score} - ${performance}`} size="small" color={color} />;
                      })() : 
                      <Chip label='No Rating' size="small" />
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
    </Box>
  )
}
